/* eslint-disable multiline-comment-style */
import React, { Suspense } from 'react'
import {
  Routes,
  Route,
  Navigate,
} from 'react-router-dom'
import ErrorHtml from '@/components/ErrorBoundary/ErrorHtml'
import configs from './config'
import IconLoading from '@/components/IconLoading'
import ErrorBoundary from '@/components/ErrorBoundary'


function RouteElement (route: RouteInfoVo) {
  const { component: Component, fallback = <IconLoading />, path, routes, ...otherRoute } = route || {}
  // useEffect(() => {
  //   reportPageType('shop', config)
  // }, [])

  return (
    <ErrorBoundary fallback={ErrorHtml}>
      <Suspense fallback={fallback}>
        <Component {...otherRoute} routes={routes} />
      </Suspense>
    </ErrorBoundary>
  )
}

// 深度遍历路由配置
const deepLoopRoute = (routeConfig: RouteConfigVo[]) => (routeConfig.map(route => (
  <Route key={route.path} path={route.path} element={<RouteElement {...route}  />} >
    {
      route.children && Array.isArray(route.children) && route.children.length
        ? deepLoopRoute(route.children) : <></>
    }
  </Route>
)))

function AppRoutes () {

  return (
    <Routes>
      {deepLoopRoute(configs)}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )

}

export default  AppRoutes